import { createActions } from 'utils/actions';

/**
 * Redux actions for the ai assistant flow.
 *
 * @type {Object}
 */
export const createAISession = createActions('aiAssistant', 'CREATE_AI_SESSION', {
    asPromise: true,
});

export const sendMessage = createActions('aiAssistant', 'SEND_MESSAGE', {
    asPromise: true,
});

export const getAnswer = createActions('aiAssistant', 'GET_ANSWER', {
    asPromise: true,
});

export const createFeedback = createActions('aiAssistant', 'CREATE_FEEDBACK', {
    asPromise: true,
});

/**
 * Redux actions for the JAPI `/v2/ai-assistant` contract used by the System Admin tray. The ARIES
 * consumers keep using the actions above.
 */
export const submitAiAssistantMessage = createActions(
    'aiAssistant',
    'SUBMIT_AI_ASSISTANT_MESSAGE',
    { asPromise: true }
);

export const saveAiAssistantFeedback = createActions('aiAssistant', 'SAVE_AI_ASSISTANT_FEEDBACK', {
    asPromise: true,
});

export const getAiAssistantFeedback = createActions('aiAssistant', 'GET_AI_ASSISTANT_FEEDBACK', {
    asPromise: true,
});

export const getAiAssistantHealth = createActions('aiAssistant', 'GET_AI_ASSISTANT_HEALTH', {
    asPromise: true,
});

/**
 * PLACEHOLDER: frequently asked questions for the primary screen's suggestion chips. The contract
 * does not document this endpoint yet, so the tray falls back to the bundled copy when it fails.
 */
export const getAiAssistantSuggestions = createActions(
    'aiAssistant',
    'GET_AI_ASSISTANT_SUGGESTIONS',
    { asPromise: true }
);

export const closeAISession = createActions('aiAssistant', 'CLOSE_AI_SESSION', {
    asPromise: true,
});

export const sendEmailCloseAISession = createActions('aiAssistant', 'SEND_EMAIL', {
    asPromise: true,
});

export const getHistoryChat = createActions('aiAssistant', 'GET_HISTORY_CHAT', {
    asPromise: true,
});

export const getChatSessionDetails = createActions('aiAssistant', 'GET_CHAT_SESSION_DETAILS', {
    asPromise: true,
});

export const getChatSessionsById = createActions('aiAssistant', 'GET_CHAT_SESSIONS_BY_ID', {
    asPromise: true,
});

export const getChatHistoryPaginated = createActions('aiAssistant', 'GET_CHAT_HISTORY_PAGINATED', {
    asPromise: true,
});

export const saveAiPolicyAcceptance = createActions('aiAssistant', 'SAVE_AI_POLICY_ACCEPTANCE', {
    asPromise: true,
});

export const getAiAssistantFaqs = createActions('aiAssistant', 'GET_AI_ASSISTANT_FAQS', {
    asPromise: true,
});

export const getAiAssistantChats = createActions('aiAssistant', 'GET_AI_ASSISTANT_CHATS', {
    asPromise: true,
});

export const getAiAssistantChatById = createActions('aiAssistant', 'GET_AI_ASSISTANT_CHAT_BY_ID', {
    asPromise: true,
});

export const createAiAssistantChat = createActions('aiAssistant', 'CREATE_AI_ASSISTANT_CHAT', {
    asPromise: true,
});

export const continueAiAssistantChat = createActions('aiAssistant', 'CONTINUE_AI_ASSISTANT_CHAT', {
    asPromise: true,
});

export const exportAiAssistantConversation = createActions(
    'aiAssistant',
    'EXPORT_AI_ASSISTANT_CONVERSATION',
    {
        asPromise: true,
    }
);

export const renameAiAssistantChat = createActions('aiAssistant', 'RENAME_AI_ASSISTANT_CHAT', {
    asPromise: true,
});

export const deleteAiAssistantChat = createActions('aiAssistant', 'DELETE_AI_ASSISTANT_CHAT', {
    asPromise: true,
});
